import { render } from "./Sensors.vue?vue&type=template&id=127f05d4&scoped=true&ts=true"
import script from "./Sensors.vue?vue&type=script&lang=ts"
export * from "./Sensors.vue?vue&type=script&lang=ts"

import "./Sensors.vue?vue&type=style&index=0&id=127f05d4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127f05d4"]])

export default __exports__